'use client';

import { ReactNode } from 'react';
import { useSessionAttributionTrackingTimer } from './useSessionAttributionTrackingTimer';

/**
 * Provider that initializes session attribution tracking.
 * Tracks landing page and apply click sources for Reward Gateway lead attribution.
 *
 * Use ONLY in root layout - handles session init and activity heartbeat timer.
 */
export function SessionAttributionProvider({
  children,
}: {
  children: ReactNode;
}) {
  useSessionAttributionTrackingTimer();
  return <>{children}</>;
}
